import React, { useEffect, useState } from 'react';
import './Header.css';
import image from "../../../assets/girl-power.png";
import mapLink from '../../../assets/mapLink.svg'
import { ReactComponent as InfoIcon } from '../../../assets/information.svg';
import { ReactComponent as ChatIcon } from '../../../assets/chat-processing.svg';
import { ReactComponent as MenuIcon } from '../../../assets/menu.svg';
import { ReactComponent as MapIcon} from '../../../assets/mapIcon.svg';
import { ReactComponent as LoginIcon} from '../../../assets/Icons/login.svg';

import {useHistory, useLocation, Link} from "react-router-dom"

import Contact from '../../Contact';
import About from '../../About';
import Callout from '../../Callout';
// Componentes auxiliares

function HeaderLink({ onClick, title, Icon }) {
    return (
        <div
            className={'label-container'}
            onClick={onClick}
            id={title+'-button'}
        >
            <Icon className='label-icon'/>
            <label className='label-title'>{title}</label>
        </div>
    )
}

export default function Header(){
    const [{ width }, setDimension] = useState({ width: window.innerWidth, height: window.innerHeight });
    const [dropMenuOpen, setDropMenuOpen] = useState(false);
    const [curCallout, setCurCallout] = useState(0);
    const history = useHistory();
    const location = useLocation();

    function handleInfo(){
        history.push('/about')
    }

    function handleLogin(){
        history.push('/login')
    }

    function MenuItem({ title, Content, Icon }) {
        const [itemExpanded, setItemExpanded] = useState(false);
        return(
            <>
                <HeaderLink
                    Icon={Icon}
                    title={title}
                    onClick={
                        title === 'Contato' ?
                        () => setItemExpanded(!itemExpanded)
                        :
                        () => handleInfo()
                    }
                />
                <div
                    id='content'
                    className={itemExpanded ? 'content' : 'content-hiden'}
                >
                    <Content />
                </div>
            </>
        );
    }

    function onClickLink(link) {
        if(curCallout === link) {
            setCurCallout(0); // Fecha o callout
        } else {
            setCurCallout(link);
        }
    }

    const updateWindowDimensions = () => {
        setDimension({ width: window.innerWidth, height: window.innerHeight });
    };

    useEffect(() => {
        window.addEventListener('resize', updateWindowDimensions);
        return () => window.removeEventListener('resize', updateWindowDimensions);
    }, []);

    useEffect(() => {
        if(width > 540 && dropMenuOpen) {
            setDropMenuOpen(false);
        } else if(width < 540 && curCallout) {
            setCurCallout(0);
        }
    }, [width, dropMenuOpen, curCallout]);

    
    return (
        <header>
            <div id="geral">
                <div className="left-content">
                    <div id="boximg">
                        <img src={image} className="img_logo" alt="logo do aplicativo" id="img_logo" />
                    </div>           
                    <div className="titulo">
                        <h1 className="titulo1">APLICATIVO DE </h1>
                        <h1 className="titulo2">SEGURANÇA DA MULHER</h1>
                    </div>
                </div>
                <div className='right-content'>
                    {width > 540 ? // pc
                        <>
                            {
                                location.pathname === '/about' ?
                                <Link to ='/'>
                                    <img id='mapa-button' src={mapLink} alt="map" className='map-icon'/> 
                                </Link> :
                                null
                            }
                            <HeaderLink title='Contato' Icon={ChatIcon} onClick={() => onClickLink(1)}/>
                            <HeaderLink title='Sobre' Icon={InfoIcon} onClick={() => handleInfo()}/>
                            <HeaderLink title='Acesso Ouvidoria' Icon={LoginIcon} onClick={() => handleLogin()}/>

                        </>
                    : // mobile
                        <div
                            id='menu-button'
                            className={ dropMenuOpen ?  'menu-button-active' : 'menu-button' }
                            onClick={() => setDropMenuOpen(!dropMenuOpen)}
                        >
                            <MenuIcon className='menu-icon'/>
                        </div>
                    }
                </div>
            </div>
            <div
                id='menu'
                className= {dropMenuOpen ? 'menu-open' : 'menu-closed'}
            >
                <MenuItem Content={Contact} Icon={ChatIcon} title='Contato'/>
                {
                    location.pathname === '/' ?
                        <Link to ='/about'>
                            <MenuItem Content={About} Icon={InfoIcon} title='Sobre'/>
                        </Link> :
                        <Link to ='/'>
                            <MenuItem Content={About} Icon={MapIcon} title='Mapa'/>
                        </Link>
                }
                {/* <MenuItem Content={About} Icon={LoginIcon} title='Login'/> */}
                <HeaderLink title='Login' Icon={LoginIcon} onClick={() => handleLogin()}/>

            </div>
            {curCallout ?
                <Callout onClickOutSide={() => setCurCallout(0)}>
                    {
                        {
                            1: <Contact/>,
                            2: <About/>,
                        }[curCallout]
                    }
                </Callout>
            : null }
        </header>
    )
}
